import { classNames } from "utils/helpers";

export default function Loading({
  large = false,
  padding = false,
}: {
  large?: boolean;
  padding?: boolean;
}) {
  const renderLoading = () => (
    <div className="text-center">
      <div role="status">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="200"
          height="200"
          viewBox="0 0 200 200"
          fill="none"
          color="#0D493B"
          className={classNames(
            large ? "h-24 w-24" : "h-10 w-10",
            "inline animate-spin"
          )}
        >
          <defs>
            <linearGradient id="spinner-secondHalf">
              <stop offset="0%" stopOpacity="0" stopColor="currentColor" />
              <stop offset="100%" stopOpacity="0.5" stopColor="#00DEA3" />
            </linearGradient>
            <linearGradient id="spinner-firstHalf">
              <stop offset="0%" stopOpacity="1" stopColor="currentColor" />
              <stop offset="100%" stopOpacity="0.5" stopColor="#00DEA3" />
            </linearGradient>
          </defs>
          <g strokeWidth="8">
            <path
              stroke="url(#spinner-secondHalf)"
              d="M 4 100 A 96 96 0 0 1 196 100"
            />
            <path
              stroke="url(#spinner-firstHalf)"
              d="M 196 100 A 96 96 0 0 1 4 100"
            />
            <path
              stroke="currentColor"
              strokeLinecap="round"
              d="M 4 100 A 96 96 0 0 1 4 98"
            />
          </g>
        </svg>
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );

  if (padding) {
    return <div className="space-y-8 py-8">{renderLoading()}</div>;
  }

  return renderLoading();
}
